import React, { useState } from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import { IoArrowBack, IoArrowForward } from 'react-icons/io5'; // Import arrow icons

const ContactLinks = ({ phoneNumber, whatsappNumber }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle the visibility of contact links
  const toggleContactLinks = () => {
    setIsOpen(!isOpen);
  };

  // Define the pre-filled message for WhatsApp
  const preFilledMessage = "Hello, I need assistance"; 

  // Properly URL encode the message for WhatsApp
  const encodedMessage = encodeURIComponent(preFilledMessage); 

  return (
    <div>
      {/* Contact Links Section */}
      {isOpen && (
        <div style={{
          position: 'fixed',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#B80000', // Red background
          borderRadius: '0 10px 10px 0', // Rounded on the right side
          padding: '20px 10px',
          zIndex: 1000
        }}>
          {/* Toggle Arrow Button */}
          <div 
            style={{
              cursor: 'pointer',
              marginBottom: '10px',
              backgroundColor: '#B80000',
              borderRadius: '50%',
              padding: '5px',
            }} 
            onClick={toggleContactLinks}
          >
            {isOpen ? (
              <IoArrowBack style={{ fontSize: '24px', color: '#fff' }} />
            ) : (
              <IoArrowForward style={{ fontSize: '24px', color: '#fff' }} />
            )}
          </div>

          {/* Phone Link */}
          <a 
            href={`tel:${9962690905}`} 
            style={{ textDecoration: 'none', fontSize: '24px', color: '#fff', marginBottom: '20px' }}
          >
            <FaPhone />
          </a>
          
          {/* WhatsApp Link with pre-filled message */}
          <a 
            href={`https://wa.me/${9962690905}?text=${encodedMessage}`} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ textDecoration: 'none', fontSize: '24px', color: '#25D366' }}
          >
            <FaWhatsapp />
          </a>
        </div>
      )}

      {/* Arrow Button for Opening the Contact Links */}
      {!isOpen && (
        <div 
          style={{
            position: 'fixed',
            left: '0',
            top: '60%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: 1001,
            backgroundColor: '#B80000',
            borderRadius: '0 10px 10px 0',
            padding: '10px',
          }} 
          onClick={toggleContactLinks}
        >
          <IoArrowForward style={{ fontSize: '24px', color: '#fff' }} />
        </div>
      )}
    </div>
  );
};

export default ContactLinks;
